import { Box, BoxProps } from '@mui/material';
import { styled, alpha, lighten } from '@mui/material/styles';

interface ContentWrapperProps extends BoxProps {
  collapsed?: boolean;
}

export const LayoutWrapper = styled(Box)(
  ({ theme }) => `
    flex: 1;
    height: 100%;

    .MuiPageTitle-wrapper {
      background: ${
        theme.palette.mode === 'dark'
          ? theme.colors.alpha.trueWhite[5]
          : theme.colors.alpha.white[50]
      };
      margin-bottom: ${theme.spacing(4)};
      box-shadow: ${
        theme.palette.mode === 'dark'
          ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15
            )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
          : `0px 2px 4px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.1
            )}, 0px 5px 12px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.05
            )}`
      };
    }
`
);

export const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<ContentWrapperProps>(({ theme, collapsed }) => `
    position: relative;
    z-index: 5;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100vh;
    padding-top: ${theme.header.height};
    margin-left: ${collapsed ? '50px' : theme.sidebar.width};
`
);
